module.exports = __webpack_public_path__ + "img/advantage2.2b505326.png";